/**
 * Selling fee charged on every sellback, in basis points of the buyback offer.
 * The fee is computed on the offer (90% reveal / 85% daily), not on FMV.
 * Shared between the API (authoritative credit math) and the web (display).
 */
export const SELLBACK_FEE_BPS = 350;

/** Fee in integer cents on a buyback offer, rounded to the nearest cent. */
export function sellbackFeeCents(offerCents: number | null | undefined): number | null {
  if (typeof offerCents !== "number" || !Number.isSafeInteger(offerCents) || offerCents <= 0) return null;
  return Math.round((offerCents * SELLBACK_FEE_BPS) / 10_000);
}

/** Net amount credited to the wallet after the selling fee. */
export function sellbackNetCents(offerCents: number | null | undefined): number | null {
  const fee = sellbackFeeCents(offerCents);
  if (fee == null) return null;
  return (offerCents as number) - fee;
}
